import React, { useState } from 'react'
import { Button, Collapse,notification } from 'antd'
import { chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { RowTable } from '../../../article/articleView/RowTable'
import ReactHtmlParser from 'react-html-parser'
import ApprovalAbstractDrawer from '../abstractPages/ApprovalAbstractDrawer'
// import { SendAbstractEmailAction } from '../../actions'
import { useDispatch } from 'react-redux'
import {ApproveAbstract} from "../../views/actions"


const { Panel } = Collapse

const ApprovedAbstractDetails = (props) => {
  let { abstract,onRefresh } = props
  let {
    approvedAbstractDate,
    invoice
  } = abstract

  let headerTitle = `Approved ${approvedAbstractDate ? `(${DisplayDate(approvedAbstractDate)})` : ''}`
  let [visibleApprovedAbstractDrawer, setVisibleApprovedAbstractDrawer] = useState(false)
  let dispatch = useDispatch()

  let events = {
    show: () => {
      setVisibleApprovedAbstractDrawer(true)
    },
    hide: () => {
      setVisibleApprovedAbstractDrawer(false)
    }
  }

  let BtnAction = (event) => {
    events.show()
    event.stopPropagation()
  }

  // let resendApprovedAbstract = (event) => {
  //   event.stopPropagation()
  //   chooseEmailModalFxn({
  //     callback: async (email) => {
  //       let obj = {
  //         id: abstract._id,
  //         fromEmail: email,
  //         template: 'approvedAbstract',
  //         type: 'abstract',
  //         attachmentArr: ['invoice']
  //       }
  //       let resp = await dispatch(SendAbstractEmailAction({
  //         email: obj.fromEmail,
  //         id: abstract._id,
  //         obj,
  //         template: obj.template
  //       }))
  //       // if (resp && resp.success) {
  //       //   // If you have a specific dispatch for reloading abstract, put it here
  //       //   // dispatch({ type: 'START_LOAD_ABSTRACT' })
  //       //   setTimeout(() => window.location.reload(), 100)
  //       // }
  //       if (resp && resp.success) {
  //         dispatch({ type: 'START_LOAD_ABSTRACT' });
  //         // 🟢 Silent refresh instead of reload
  //         if (onRefresh) onRefresh();
  //       }
  //     }
  //   })
  // }
  let resendApprovedAbstract = (event) => {
    event.stopPropagation();

    chooseEmailModalFxn({
      callback: async (email) => {
        const valData = {
          abstractId: abstract._id,
          fromEmail: email,
          template: 'approvedAbstract',
          isUpdate: true,
          sendEmail: true,
          affiliationData: abstract.affiliationData,
          publicationCharges: abstract.publicationCharges,
          doiAuthors: abstract.doiAuthors,
          noOfAuthors: abstract.noOfAuthors
        };

        // 2. Dispatch the same ApproveAbstract action used in handleSubmit
        let { success } = await dispatch(ApproveAbstract(valData));

        // 3. Handle the UI response consistently
        if (success) {
          notification.success({
            message: 'Success',
            description: 'Approved abstract email resent successfully.'
          });

          dispatch({ type: 'START_LOAD_ABSTRACT' });

          if (onRefresh) {
            onRefresh();
          }
        }
      }
    });
  };
  let getExtraButton = () => {
    return (
      <React.Fragment>
        {/* Shows ADD button if it hasn't been approved yet */}
        {!approvedAbstractDate ?
          <Button type={'primary'} size={'small'} onClick={BtnAction}>Add</Button> : null}

        {/* Shows EDIT button if it has already been approved */}
        {approvedAbstractDate ?
          <Button type={'primary'} size={'small'} onClick={BtnAction}>Edit</Button> : null}

        {/* Shows RESEND button if it is currently Approved */}
        {abstract.approvedAbstractDate && abstract.status === 'Approved Abstract' ?
          <Button type={'primary'} size={'small'} onClick={resendApprovedAbstract} className={'ml-5'}>
            Resend Approval
          </Button> : null}
      </React.Fragment>
    )
  }

  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Date'} value={
              approvedAbstractDate && DisplayDate(approvedAbstractDate)
            }/>
            <RowTable title={'Special Note'} value={
              abstract.approvalSpecialNote ? ReactHtmlParser(abstract.approvalSpecialNote) : null
            }/>
            <RowTable title={'Approval Amount'} value={
              abstract.publicationCharges ? ReactHtmlParser(String(abstract.publicationCharges)) : null
            }/>
            <RowTable title={'Uploaded Invoice'} value={
              invoice && invoice.path ?
                <a download className='downloadLink' target={'_blank'}
                   href={invoice.path}>Download</a> : 'No Attachment'
            }/>
          </div>
        </Panel>
      </Collapse>

      {visibleApprovedAbstractDrawer ? <ApprovalAbstractDrawer
        visible={visibleApprovedAbstractDrawer}
        abstractId={abstract._id}
        abstract={abstract}
        edit={!!approvedAbstractDate}
        onClose={() => events.hide()}
        callback={onRefresh}
      /> : null}
    </div>
  )
}

export default ApprovedAbstractDetails
